import React from "react";
import FD from "../../../assets/images/fixed-deposit.png";
import BodyMass from "../../../assets/health/body-mass.png"
import SegmentalWeight from "../../../assets/health/segmental-weight.png"
import IdealBodyWeight from "../../../assets/health/ideal-body-weight.png"
import NutriRequire from "../../../assets/health/nutrition1.png"
import EGFR from "../../../assets/health/egfr.png"
import BodySurface from "../../../assets/health/body-surface-area.png"
import Term from "../../../assets/images/term-insurance.png";
import Child from "../../../assets/images/child-education.png";
import Recurring from "../../../assets/images/recurring.png";
import SIP from "../../../assets/images/sip.png";
import Retirement from "../../../assets/images/retirement.png";
import IncomeImg from "../../../assets/images/income-tax.png";
import CagrImg from "../../../assets/images/compound.png";
import Mutual from "../../../assets/images/mutual.png";
import PresetMoney from "../../../assets/images/current-account.png";
import FutureMoey from "../../../assets/images/future.png";
import Health from "../../../assets/images/health.png";
import PPF from "../../../assets/images/ppf.png";
import Ulip from "../../../assets/images/ulip-cal.png";
import "./home.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function Home() {
  let navigate = useNavigate();

  useEffect(()=>{
    // console.log()
  },[])
  return (
    <div className="container pt-0 pb-5 mt-5">
      <br/><br/><br/>
      <div className="col-md-12 pt-0" style={{ margin: "auto" }}>
        <div className="row pt-0">
          {/* <div className="path-text mx-md-3"> Calculator</div> */}
          <div className="mt-4 fd-cal-text mb-3 mx-md-3"></div>
         <h3 className="pb-3"><b>Finantial Calculators</b></h3>
          <div className="col-3 col-lg-2  d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/fd-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                Fixed Deposit 
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={FD} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2  d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/term-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                  Term Insurance
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={Term} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2  d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/child-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                  Child Education
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={Child} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2  mt-0 mt-lg-0 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/rd-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                  RD
                  <br />
                  Calculator
                </div>
              </div>
              <img
                className="card-img-top mb-lg-4 mb-3"
                src={Recurring}
                alt=""
              />
            </div>
          </div>
          <div className="col-3 col-lg-2 mt-3 mt-md-3 mt-lg-0 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/sip-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                  SIP
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={SIP} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2  mt-md-3 mt-lg-0 mt-3 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/retirment-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                  Retirement
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={Retirement} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2 mt-3  mt-md-3 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/ppf-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                  PPF
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={PPF} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2 mt-3 mt-md-3 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/incometax-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                  Income Tax
                  <br />
                  Calculator
                </div>
              </div>
              <img
                className="card-img-top mb-lg-4 mb-3"
                src={IncomeImg}
                alt=""
              />
            </div>
          </div>
          <div className="col-3 col-lg-2 mt-3 mt-md-3 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/cagr-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                  CAGR
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={CagrImg} alt="" />
            </div>
          </div>
          {/* <div className="col-3 col-lg-2  mt-md-3 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/mutual-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                  Mutual Fund <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={Mutual} alt="" />
            </div>
          </div> */}

          <div className="col-3 col-lg-2 mt-3 mt-md-3 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/future-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                Future Value  <br />
                 Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={FutureMoey} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2 mt-3 mt-md-3 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/present-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                Present Value  <br />
                Calculator 
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={PresetMoney} alt="" />
            </div>
          </div>     
          <div className="col-3 col-lg-2 mt-3 mt-md-3 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/medical-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                 Medical<br />
                 Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={Health} alt="" />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="col-md-12 pt-0" style={{ margin: "auto" }}>
        <div className="row pt-0">
          <div className="mt-4 fd-cal-text mb-3 mx-md-3"></div>
         <h3 className="pb-3"><b>Health Calculators</b></h3>
          <div className="col-3 col-lg-2  d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/bmi-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                Body Mass Index
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={BodyMass} alt="" />
            </div>
          </div>
          
          <div className="col-3 col-lg-2  d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/ibw-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                Ideal Body Weight
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={IdealBodyWeight} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2 mt-3 mt-md-3 mt-lg-0 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/eGFR");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                eGFR
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={EGFR} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2  mt-md-3 mt-lg-0 mt-3 d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/retirment-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                Body Surface Area
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={BodySurface} alt="" />
            </div>
          </div>
          <div className="col-3 col-lg-2  d-flex justify-content-center text-center">
            <div
              className="card"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/term-calulator");
              }}
            >
              <div className="card-body">
                <div className="card-text mt-xl-3">
                Segmental Weight
                  <br />
                  Calculator
                </div>
              </div>
              <img className="card-img-top mb-lg-4 mb-3" src={SegmentalWeight} alt="" />
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );  
}
